import * as React from 'react'
import * as CMS from '../../types/SitecoreAdapter'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import Helmet from 'react-helmet'

const EXCLUDE_PATH_REGEXES = [
  /^\/search\/?$/i,
  /^\/start-quote\/?$/i,
];



const isDisallowedHost = (host: string): boolean => {
  const labels   = host.toLowerCase().split('.');
  const subParts = labels.slice(0, -2); // everything before the root domain

  if (subParts.length === 0) return false;
  if (subParts.length === 1 && subParts[0] === 'www') return false;
  if (subParts.includes('cm')) return false;
  if (subParts.includes('cm-preview')) return false;   
  if (subParts.includes('cd-web')) return false;      
  if (subParts.includes('cd-preview')) return false;   
  if (subParts.includes('cd-active')) return false;   
  return true;
};

const shouldIndex = (rawUrl?: string): boolean => {
  if (!rawUrl) return true;

  let parsed: URL;
  try {
    parsed = new URL(rawUrl, 'https://dummy-base'); // placeholder origin
  } catch {
    return true;
  }

  if (isDisallowedHost(parsed.hostname)) return false;
  return !EXCLUDE_PATH_REGEXES.some((rx) => rx.test(parsed.pathname));
};

export const RobotsMeta = ({ index }: { index: boolean }) => {
  const policy = index ? 'index, follow' : 'noindex, nofollow'
  return (
    <Helmet>
      <meta name="robots" content={policy} />
    </Helmet>
  )
}

type RobotsAdapterProps = CMS.RouteFields<{
  url: string
}>

export const RobotsAdapter = ({
  sitecoreContext: {
    route: {
      fields: { url },
    },
  },
}: RobotsAdapterProps) => {
  return <RobotsMeta index={shouldIndex(url)} />;
};

export const RobotsWired = withSitecoreContext()(RobotsAdapter)
